export const HOME_META_TAGS = {
  title: 'bamba travel adventures - Curated, tailor-made experiences',
  description: 'Discover the globe independently yet never alone. Enjoy unique experiences, from hiking the Inca Trail to authentic local adventures, all tailored to your travel preferences and budget.',
  image: 'assets/img/home_preview.jpg',
};

